/**
 * Whether a page's next cursor leads to a page not yet shown. None leads
 * nowhere, and nor does a cursor handed back as it was given.
 */
export function leadsOn(
    nextCursor: string | null | undefined,
    cursor: string | undefined,
): boolean {
    return Boolean(nextCursor) && nextCursor !== cursor;
}
